// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

import * as types from '../actions/actionTypes';
import initialState from './intialState';

// eslint-disable-next-line default-param-last
export default function tokenValidationErrorReducer (state = initialState.tokenValidationError, action) {
	switch (action.type) {
		case types.SET_TOKEN_VALIDATION_ERROR: {
			return action.payload;
		}
		default: {
			return state;
		}
	}
}
